import { app } from '@microsoft/teams-js';

import { rejectAfter } from '../promises';

import { MetaOsHubNotFoundError } from './error';

export type MetaOsHubContext = app.Context;

type EnsureInitialized = () => Promise<void>;
export const ensureInitialized: EnsureInitialized = async () => {
  if (!app.isInitialized()) {
    await app.initialize();
  }
};

type GetMetaOsHubContext = () => Promise<MetaOsHubContext | null>;
export const getMetaOsHubContext: GetMetaOsHubContext = async () => {
  try {
    await ensureInitialized();
    const context = await Promise.race([app.getContext(), rejectAfter(5000, new Error())]);

    return context;
  } catch {
    return null;
  }
};

type GetMetaOsHubContextThrows = () => Promise<MetaOsHubContext>;
export const getMetaOsHubContextThrows: GetMetaOsHubContextThrows = async () => {
  const context = await getMetaOsHubContext();

  if (context == null) {
    throw new MetaOsHubNotFoundError('Failed to get MetaOS context: not loaded inside MetaOS hub.');
  }

  return context;
};

type HasMetaOsHubContext = () => Promise<boolean>;
export const hasMetaOsHubContext: HasMetaOsHubContext = async () => !!(await getMetaOsHubContext());
